import React from "react"

export const AccordionTab = ({
  content,
  index,
  is_inverted,
  last_tab,
  selectedTab,
  setSelectedTab,
  title,
}) => {
  const select_tab = () => setSelectedTab(is_selected ? -1 : index)
  const is_selected = index === selectedTab

  return (
    <React.Fragment>
      <div className="columns is-mobile my-0">
        <div
          onClick={select_tab}
          onKeyDown={() => {}}
          tabIndex="-1"
          role="button"
          className="column is-narrow pl-0 is-clickable"
        >
          <AccordionSymbol
            {...{ is_selected, color: is_inverted ? "#FFFFFF" : undefined }}
          />
        </div>
        <div className="column">
          <div
            onClick={select_tab}
            onKeyDown={() => {}}
            tabIndex="-2"
            role="button"
            className={`has-text-weight-bold mb-3 is-clickable has-text-${
              is_inverted ? "white" : "mitternachtsblau"
            }`}
          >
            {title}
          </div>
          <div
            className="content"
            style={{
              maxHeight: is_selected ? 1000 : 0,
              opacity: is_selected ? 1 : 0,
              visibility: is_selected ? "visible" : "hidden",
              transition: "all 0.5s ease",
              color: is_inverted ? "white" : "#034055",
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>
        </div>
      </div>
      {!last_tab ? (
        <hr className="is-mitternachtsblau-10 mt-1 mb-2 is-slim" />
      ) : null}
    </React.Fragment>
  )
}

export const AccordionSymbol = ({
  is_selected,
  size = 1,
  color = "#034055",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16 * size}
    height={16 * size}
    style={{
      marginTop: "5px",
      transform: is_selected ? "rotate(90deg)" : "rotate(0deg)",
      transition: "all 0.2s ease",
      overflow: "visible",
      enableBackground: "new 0 0 16 16",
    }}
    xmlSpace="preserve"
  >
    <path
      style={{
        opacity: is_selected ? 0 : 1,
        transition: "all 0.1s ease",
        fill: "none",
        stroke: color,
        strokeWidth: 3,
      }}
      d="M0 8h16M8 0v16"
    />

    <path
      d="M8 0v16"
      style={{
        opacity: is_selected ? 1 : 0,
        transition: "all 0.1s ease",
        fill: "none",
        stroke: color,
        strokeWidth: 3,
      }}
    />
  </svg>
)
